module.exports = __webpack_public_path__ + "background.png?5761116cf19709f47bf8bc34a756fbbf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.png
// module id = 22
// module chunks = 0